import { create } from 'zustand';

type ViewReadProps = {
    isVisibleModal: boolean;
    isReaded: boolean;
};

type State = {
    // Documento de regulamento
    regulation: ViewReadProps;
};

type Action = {
    setRegulation: (regulation: ViewReadProps) => void;
};

export const useTermsStore = create<State & Action>(set => ({
    regulation: {
        isVisibleModal: false,
        isReaded: false,
    },

    setRegulation: regulation => {
        set(() => ({
            regulation,
        }));
    },
}));
